// @flow
import  React, { PureComponent } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import Icon from '../Icon';
import { RCTModal as Modal } from './RCTModal';
import theme from '../../../theme-config';

export default class FullScreenModal extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    const { children: content, ...props } = this.props;
    return (
      <Modal {...props} animationType="slide" visible={this.props.visible} onRequestClose={this.props.onRequestClose}>
        <SafeAreaView style={[styles.safeareaview, this.props.containerStyle]}>
          {content}
          <TouchableOpacity
            delayPressIn={0}
            onPress={this.props.onRequestClose}
            style={styles.iconContainer}
            activeOpacity={0.7}
          >
            <Icon name="cross" style={styles.icon} size={18} />
          </TouchableOpacity>
        </SafeAreaView>
      </Modal>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    safeareaview: {
      flex: 1,
      backgroundColor: 'transparent',
      marginTop: 24,
    },
    iconContainer: {
      height: 50,
      width: 50,
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: 10,
      left: 0,
    },
    icon: {
      color: theme.signUpTextColor,
      backgroundColor: 'transparent',
    },
  });

type Props = {
  visible: boolean,
  children?: any,
  onRequestClose: () => void,
  containerStyle: any,
};
